import React, { PropsWithChildren } from "react";
import {
  Box,
  AlertColor,
  styled,
  BoxProps,
  Stack,
  IconButton,
  SxProps,
} from "@mui/material";
import SuccessOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Link } from "react-router-dom";
import { Theme } from "@mui/material/styles";

type AlertTitleProps = {
  severity: AlertColor;
  icon?: React.JSX.Element;
  iconSx?: SxProps<Theme>;
  time?: string;
  alarmId?: number;
  clearFunction?: (id: number) => void;
  notif?: boolean;
  redirectTo?: string;
};

export const AlertIcon = styled(Box)({
  display: "flex",
  alignItems: "center",
  marginRight: "0.7rem",
});
const TitleContainer = styled(
  ({ severity, ...props }: BoxProps & Pick<AlertTitleProps, "severity">) => (
    <Box {...props} />
  )
)(({ theme, severity }) => ({
  display: "flex",
  padding: "0rem 0.7rem",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const iconMapping = {
  success: <SuccessOutlinedIcon fontSize="inherit" />,
  warning: <ReportProblemOutlinedIcon fontSize="inherit" />,
  error: <ErrorOutlineIcon fontSize="inherit" />,
  info: <InfoOutlinedIcon fontSize="inherit" />,
};

const AlertTitle = ({
  icon,
  iconSx,
  severity,
  children,
  time,
  alarmId,
  clearFunction,
  notif,
  redirectTo,
}: PropsWithChildren<AlertTitleProps>) => {
  return (
    <TitleContainer severity={severity} data-testid="alert-title">
      <Stack direction="row">
        <AlertIcon sx={iconSx}>{icon || iconMapping[severity]}</AlertIcon>
        {redirectTo ? (
          <Link
            to={redirectTo}
            style={{
              color: "inherit",
              textDecoration: "inherit",
              fontWeight: "bold",
            }}
          >
            {children}
          </Link>
        ) : (
          <Box
            sx={{
              flex: 1,
              fontWeight: "bold",
            }}
          >
            {children}
          </Box>
        )}

        <Box>{time}</Box>
      </Stack>
      {notif && (
        <IconButton
          onClick={() => clearFunction && alarmId && clearFunction(alarmId)}
        >
          <HighlightOffIcon />
        </IconButton>
      )}
    </TitleContainer>
  );
};

export default AlertTitle;
